var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-content main_center",
      style: _vm.mainContentViewHeight,
    },
    [
      _c(
        "div",
        { staticClass: "edit-form" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.tableChange },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "数据集列表", name: "basicInfo" } },
                [
                  _vm.isRouterAlive
                    ? _c("config-dataset-list", {
                        attrs: { formId: _vm.formId },
                        on: {
                          "update:formId": function ($event) {
                            _vm.formId = $event
                          },
                          "update:form-id": function ($event) {
                            _vm.formId = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "查询参数配置", name: "searchArg" } },
                [
                  _vm.isRouterAlive
                    ? _c("config-search-arg", {
                        attrs: { formId: _vm.formId },
                        on: {
                          "update:formId": function ($event) {
                            _vm.formId = $event
                          },
                          "update:form-id": function ($event) {
                            _vm.formId = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "字段映射", name: "datasetField" } },
                [
                  _vm.isRouterAlive
                    ? _c("config-dataset-field", {
                        attrs: { formId: _vm.formId },
                        on: {
                          "update:formId": function ($event) {
                            _vm.formId = $event
                          },
                          "update:form-id": function ($event) {
                            _vm.formId = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }